const uploadFileTypes = {
  SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
  SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
  SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
  FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE',
}

export default uploadFileTypes
